import { Product, SearchFilter } from '@rygen/rygen-ui/model';

/**
 * A payload for a product quick search
 */
export class ProductSearchPayload extends SearchFilter<Product> {
  criteria: string = '';
  pageSize: number = 10;

  constructor(opts?: Partial<ProductSearchPayload>) {
    super(opts);

    if (opts?.criteria != null) {
      this.criteria = opts.criteria;
    }
  }
}
